var React = require('react');

function BurgerInline (props) {
    return React.createElement("svg",props,[React.createElement("line",{"x1":"9","y1":"14","x2":"31","y2":"14","strokeWidth":"2","strokeLinecap":"round","key":0}),React.createElement("line",{"x1":"9","y1":"24","x2":"31","y2":"24","strokeWidth":"2","strokeLinecap":"round","key":1})]);
}

BurgerInline.defaultProps = {"viewBox":"0 0 40 40","fill":"none"};

module.exports = BurgerInline;

BurgerInline.default = BurgerInline;
